import { Component, OnInit } from '@angular/core';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver/FileSaver';
import { ModalBulkLoadComponent } from 'app/modal-bulk-load/modal-bulk-load.component';
import { ModalErrorPaymentComponent } from '../modal-error-payment/modal-error-payment.component';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-bulk-load',
  templateUrl: './bulk-load.component.html',
  styleUrls: ['./bulk-load.component.scss']
})
export class BulkLoadComponent implements OnInit {
  list=[];
  userToken='';
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providerActive = 'hide';
  providersList=[];
  data: any = {};
  isExternal;
  perfilId;
  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];
  userId;
  temp;
  showContent  = false;

  constructor(private translate: TranslateService,private toastr: ToastrService, public dialog: MatDialog,  private provService: ProvidersService,private gralService: GeneralService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('BULKLOAD');

    //this.getOrders();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == 2 || this.perfilId == 3 )? 'show': 'hide';
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
      this.data.FechaFin = new Date();
  }

  /* ********************* filtros ************** */
  search(){
    this.data.Proveedor = this.arrOc.join();

    if(!this.data.FechaInicio || !this.data.FechaFin){
      let body = "Favor de ingresar todos los campos";
      if(this.translate.currentLang == "es"){
        body = "Favor de ingresar todos los campos";
      }else if(this.translate.currentLang == "en"){
        body = "Please enter all fields";
      }
      this.toastr.error(body, 'Error');
      return;
    }

    this.list = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {FechaFin: datePipe.transform(dateend, 'yyyy/MM/dd'), FechaInicio: datePipe.transform(dateinit, 'yyyy/MM/dd'), Proveedores: this.data.Proveedor};

    this.provService.getBulkLoad(params, this.userToken).then((data:any) => {
      this.loadBtn = false;
      this.list = data['Entidades'];
      this.temp= data['Entidades'];
      this.showContent = true;

      if(this.list.length > 0){
        this.reorderDataExportExcel(this.list);
      }

      if(this.list.length == 0){
        let title = "Sin datos";
        let body = "No se encontraron resultados para su busqueda";
        if(this.translate.currentLang == "es"){
          title = "Sin datos";
          body = "No se encontraron resultados para su busqueda";
        }else if(this.translate.currentLang == "en"){
          body = "No results for your search";
          title = "No data";
        }
        this.toastr.success(body,title);
        return false;
      }

    }, (err) => {
        console.log(err);
        this.list = null;
        this.showContent = false;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){

        }

    });
  }

  disabledProv(){
    let resp = false;

    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;

      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){

  }

  selectSociety(pos){
    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];
      this.arrOc.push(List[pos].NumProveedor);
    }
  }
  /* ********************* filtros ************** */

  addBulk(){
    this.dialog.open(ModalBulkLoadComponent, {
      // disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { tempRegister: '' }
    }).afterClosed().subscribe(res=>{
      console.log(res);
      if(res){
        //this.listOrders();
      }
    });
  }

  openError(pos, msj){

    this.dialog.open(ModalErrorPaymentComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      data: { msjError: msj }
    });
  }

  filterStatus(val) {
    const temp = this.temp.filter(function(d) {
        if(d.Estatus == val){
          return d.Estatus;
        }
    });
    this.list = temp;
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('carga_masiva'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    const datePipe = new DatePipe('en-US');
    this.listExcel =  [];

    for(let i = 0; i < lista.length; i++){
      let contTable = lista[i].RecepcionFactura;
      let estatus;
      let msjError;
      if(lista[i].Estatus == 1){
        estatus = 'Válido';
        msjError = '';
      }else if(lista[i].Estatus == 2){
        estatus = 'Pendiente';
        msjError = lista[i].MensajeEstatus;
      }else if(lista[i].Estatus == 3){
        estatus = 'error';
        msjError = lista[i].MensajeEstatus;
      }

      let params = {
          "# Documento SAP": lista[i].NoDocumentoSAP,
          "Proveedor": lista[i].NoProveedor,
          "Sociedad" : lista[i].NoSociedad,
          "UUID" : lista[i].UUID,
          "Fecha":  datePipe.transform(lista[i].FechaPagoSAP, 'yyyy/MM/dd'),
          "Fecha carga":  datePipe.transform(lista[i].FechaCarga, 'yyyy/MM/dd'),
          "Estatus":estatus,
          "Mensaje error": msjError
      }
      this.listExcel.push(params);
    }
  }
}
